import React, { useState } from "react";
import SimpleModal from "../../SimpleModal";
import ModalUIActionButtons from "./Screens/ModalUIActionButtons";
import TableScreen from "./Screens/TableScreen";
import AcknowledgmentScreen from "./Screens/AcknowledgmentScreen";
import schema9142B from "../schema9142B";

const LinkingModal = ({
  open,
  toggle,
  allowOutOfNetwork,
  modalScreens,
  formId,
  machine_name,
  formApi,
  sortingFields,
  rnLinkingDataField,
}) => {
  const AllModalScreens = {
    SELECTION_SCREEN: TableScreen,
    ACKNOWLEDGEMENT_SCREEN: AcknowledgmentScreen,
  };

  const sortingValues = {};
  const formValues = formApi.getState().values;
  sortingFields.forEach((field) => {
    if (formValues[field]) sortingValues[field] = formValues[field];
  });
  // bring in fein, msa name fieldnames and get values
  const [screen, setScreen] = useState(modalScreens.startingScreen);
  const [modalResetFunc, setModalResetFunc] = useState(() => null);
  const [selectedRegistrationNumber, setSelectedRegistrationNumber] =
    useState(null);

  const resetAndClose = (close = true) => {
    modalResetFunc();
    setSelectedRegistrationNumber(null);
    setScreen(modalScreens.startingScreen);
    if (!!close) {
      toggle();
    }
  };

  const buildScreenProps = () => {
    const defaultProps = {
      formId,
      selectedRegistrationNumber,
    };
    const tableScreenProps = {
      schema: schema9142B.tableScreen,
      sortingValues,
      allowOutOfNetwork,
      setSelectedRegistrationNumber,
      setModalResetFunc,
      resetAndClose,
    };
    const acknowledgmentScreenProps = {
      schema: schema9142B.acknowledgmentScreen,
    };

    const propLookup = {
      SELECTION_SCREEN: tableScreenProps,
      ACKNOWLEDGEMENT_SCREEN: acknowledgmentScreenProps,
    };

    return { ...defaultProps, ...propLookup[screen] };
  };

  const CurrentScreenComponent = AllModalScreens[screen];
  const screenProps = buildScreenProps();

  return (
    <SimpleModal
      modalStatus={open}
      toggleModal={resetAndClose}
      renderButton={() => null}
      minWidth={screen !== "ACKNOWLEDGEMENT_SCREEN" ? "90%" : "40%"}
    >
      <CurrentScreenComponent {...screenProps} />
      <ModalUIActionButtons
        formId={formId}
        selectedRegistrationNumber={selectedRegistrationNumber}
        formSpecificScreens={modalScreens.all}
        screen={screen}
        setScreen={setScreen}
        resetAndClose={resetAndClose}
        rnLinkingDataField={rnLinkingDataField}
        formApi={formApi}
        machine_name={machine_name}
      />
    </SimpleModal>
  );
};

export default LinkingModal;
